var _rect, _path, _path2, _rect2, _rect3, _circle, _path3, _circle2, _path4, _rect4, _rect5, _mask, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBuroSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 122,
    height: 123,
    viewBox: "0 0 122 123",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.317383,
    width: 122,
    height: 122,
    rx: 40,
    fill: "#E5F9F1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37 48.3174C37 43.3468 41.0294 39.3174 46 39.3174H78C82.9706 39.3174 87 43.3468 87 48.3174V82.3174C87 87.2879 82.9706 91.3174 78 91.3174H46C41.0294 91.3174 37 87.2879 37 82.3174V48.3174Z",
    fill: "#00C574"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46 29.8174C40.201 29.8174 35.5 34.5184 35.5 40.3174V76.3174C35.5 82.1164 40.201 86.8174 46 86.8174H78C83.799 86.8174 88.5 82.1164 88.5 76.3174V40.3174C88.5 34.5184 83.799 29.8174 78 29.8174H46Z",
    fill: "#00C574",
    stroke: "#E5F9F1",
    strokeWidth: 3
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 61.3174,
    width: 30,
    height: 3,
    rx: 1.5,
    fill: "#7FE2B9"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 69.3174,
    width: 30,
    height: 3,
    rx: 1.5,
    fill: "#7FE2B9"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 62.1508,
    cy: 42.841,
    r: 3.52361,
    fill: "#CCF3E3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8083 53.3596C55.8083 50.4694 58.1513 48.1265 61.0414 48.1265H63.2603C66.1504 48.1265 68.4934 50.4694 68.4934 53.3596C68.4934 53.3885 68.4699 53.4119 68.441 53.4119H55.8607C55.8318 53.4119 55.8083 53.3885 55.8083 53.3596Z",
    fill: "#CCF3E3"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 92,
    cy: 60.3174,
    r: 13,
    fill: "#E5F9F1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M94.5 72.8174V46.3174C87 46.3174 80 49.8174 80 61.3174C80 70.5174 89.6667 72.8174 94.5 72.8174Z",
    fill: "#00C574"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 75,
    y: 54.3174,
    width: 15,
    height: 3,
    rx: 1.5,
    fill: "#7FE2B9"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 75,
    y: 61.3174,
    width: 15,
    height: 3,
    rx: 1.5,
    fill: "#7FE2B9"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-12-outside-1_183_5297",
    maskUnits: "userSpaceOnUse",
    x: 74,
    y: 42.3174,
    width: 40,
    height: 40,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 74,
    y: 42.3174,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.715 72.5271C98.2589 74.2837 95.2501 75.3174 92 75.3174C83.7157 75.3174 77 68.6017 77 60.3174C77 52.0331 83.7157 45.3174 92 45.3174C100.284 45.3174 107 52.0331 107 60.3174C107 63.5676 105.966 66.5764 104.21 69.0328C104.291 69.0869 104.368 69.1497 104.439 69.2213L110.096 74.8782C110.682 75.464 110.682 76.4137 110.096 76.9995L108.682 78.4137C108.096 78.9995 107.146 78.9995 106.561 78.4137L100.904 72.7569C100.832 72.6853 100.769 72.6083 100.715 72.5271ZM104 60.3174C104 66.9448 98.6274 72.3174 92 72.3174C85.3726 72.3174 80 66.9448 80 60.3174C80 53.69 85.3726 48.3174 92 48.3174C98.6274 48.3174 104 53.69 104 60.3174Z"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.715 72.5271C98.2589 74.2837 95.2501 75.3174 92 75.3174C83.7157 75.3174 77 68.6017 77 60.3174C77 52.0331 83.7157 45.3174 92 45.3174C100.284 45.3174 107 52.0331 107 60.3174C107 63.5676 105.966 66.5764 104.21 69.0328C104.291 69.0869 104.368 69.1497 104.439 69.2213L110.096 74.8782C110.682 75.464 110.682 76.4137 110.096 76.9995L108.682 78.4137C108.096 78.9995 107.146 78.9995 106.561 78.4137L100.904 72.7569C100.832 72.6853 100.769 72.6083 100.715 72.5271ZM104 60.3174C104 66.9448 98.6274 72.3174 92 72.3174C85.3726 72.3174 80 66.9448 80 60.3174C80 53.69 85.3726 48.3174 92 48.3174C98.6274 48.3174 104 53.69 104 60.3174Z",
    fill: "#00C574"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M100.715 72.5271L103.211 70.8629L101.492 68.2838L98.9703 70.0868L100.715 72.5271ZM104.21 69.0328L101.769 67.2878L99.9663 69.8093L102.545 71.5289L104.21 69.0328ZM104.439 69.2213L102.318 71.3426L104.439 69.2213ZM110.096 74.8782L112.218 72.7569L112.218 72.7569L110.096 74.8782ZM110.096 76.9995L112.218 79.1208L112.218 79.1208L110.096 76.9995ZM108.682 78.4137L110.803 80.535L110.803 80.535L108.682 78.4137ZM106.561 78.4137L104.439 80.535L104.439 80.535L106.561 78.4137ZM100.904 72.7569L103.025 70.6355V70.6355L100.904 72.7569ZM92 78.3174C95.8964 78.3174 99.5117 77.0759 102.46 74.9674L98.9703 70.0868C97.0061 71.4915 94.6039 72.3174 92 72.3174V78.3174ZM74 60.3174C74 70.2585 82.0589 78.3174 92 78.3174V72.3174C85.3726 72.3174 80 66.9448 80 60.3174H74ZM92 42.3174C82.0589 42.3174 74 50.3763 74 60.3174H80C80 53.69 85.3726 48.3174 92 48.3174V42.3174ZM110 60.3174C110 50.3763 101.941 42.3174 92 42.3174V48.3174C98.6274 48.3174 104 53.69 104 60.3174H110ZM106.65 70.7779C108.759 67.8292 110 64.2138 110 60.3174H104C104 62.9214 103.174 65.3235 101.769 67.2878L106.65 70.7779ZM102.545 71.5289C102.463 71.4741 102.387 71.4115 102.318 71.3426L106.561 67.1C106.349 66.888 106.118 66.6998 105.874 66.5368L102.545 71.5289ZM102.318 71.3426L107.975 76.9995L112.218 72.7569L106.561 67.1L102.318 71.3426ZM107.975 76.9995C107.389 76.4137 107.389 75.464 107.975 74.8782L112.218 79.1208C113.975 77.3635 113.975 74.5142 112.218 72.7569L107.975 76.9995ZM107.975 74.8782L106.561 76.2924L110.803 80.535L112.218 79.1208L107.975 74.8782ZM106.561 76.2924C107.146 75.7066 108.096 75.7066 108.682 76.2924L104.439 80.535C106.197 82.2924 109.046 82.2924 110.803 80.535L106.561 76.2924ZM108.682 76.2924L103.025 70.6355L98.7825 74.8782L104.439 80.535L108.682 76.2924ZM103.025 70.6355C103.094 70.7045 103.157 70.7807 103.211 70.8629L98.2193 74.1914C98.3822 74.4358 98.5704 74.6661 98.7825 74.8782L103.025 70.6355ZM92 75.3174C100.284 75.3174 107 68.6017 107 60.3174H101C101 65.2879 96.9706 69.3174 92 69.3174V75.3174ZM77 60.3174C77 68.6017 83.7157 75.3174 92 75.3174V69.3174C87.0294 69.3174 83 65.2879 83 60.3174H77ZM92 45.3174C83.7157 45.3174 77 52.0331 77 60.3174H83C83 55.3468 87.0294 51.3174 92 51.3174V45.3174ZM107 60.3174C107 52.0331 100.284 45.3174 92 45.3174V51.3174C96.9706 51.3174 101 55.3468 101 60.3174H107Z",
    fill: "#E5F9F1",
    mask: "url(#path-12-outside-1_183_5297)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuroSearch);
export default __webpack_public_path__ + "static/media/buroSearch.c4626befd2835b86928f7ee22e7a16b2.svg";
export { ForwardRef as ReactComponent };